import React from 'react';
import { Link } from 'react-router-dom';
import './Service.css';

function ServicesSection() {
  return (
    <section className="services-section" aria-label="Service portal access">
      <div className="services-container">
        <Link to="/portal" className="services-portal-button" aria-label="Access our service portal">
          Access Service Portal
        </Link>
      </div>
    </section>
  );
}

export default ServicesSection;